import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TileButton, TileButtonProps } from '@printdeal/ui-library';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface UploadFilesThumbButtonProps {
  thumbSize?: TileButtonProps['size'];
  thumbClasses?: string;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const UploadFilesThumbButton = ({
  thumbSize = 'lg',
  thumbClasses = '',
  dispatchEventCategory = 'order_detail_interaction',
}: UploadFilesThumbButtonProps) => (
  <TileButton
    size={thumbSize}
    type="submit"
    icon="image"
    onClick={() => dispatchAccountEvent(dispatchEventCategory, 'open_file_delivery')}
    className={thumbClasses}
  >
    <FormattedMessage id="account.order.deliverFiles.button" defaultMessage="Click here to deliver your designs" />
  </TileButton>
);

export default UploadFilesThumbButton;
